export const ROLES = {
    ROLE_SUPER: 'super',
    ROLE_ADMIN: 'admin',
    ROLE_USER: 'user',
    ROLE_GUEST: 'guest',
}

export function checkPermissions(userRole, accessRole) {
    switch (userRole) {
        case ROLES.ROLE_SUPER: {
            return true;
        }
        case ROLES.ROLE_ADMIN: {
            return true;
        }
        case ROLES.ROLE_USER: {
            if (accessRole === ROLES.ROLE_USER | ROLES.ROLE_GUEST) {
                return true
            }

            return false
        }
        case ROLES.ROLE_GUEST: {
            if (accessRole === ROLES.ROLE_GUEST) {
                return true
            }

            return false
        }
    }
}